import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import { stateCreator } from './state';
export * from './selector';

export const useCreditStore = create(subscribeWithSelector(stateCreator));
